import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography } from '@popmenu/common-ui';

import { withStyles } from '../../utils/withStyles';
import profileStyles from '../../assets/jss/shared/profileStyles';
import { currentUserShape, withCurrentUser } from '../CurrentSessionProvider';

import AuthySummary from './AuthySummary';
import Divider from '../../admin/shared/forms/Divider';
import SignOutButton from '../SignOutButton';
import UserAvatarForm from '../profile/UserAvatarForm';
import UserPasswordForm from '../profile/UserPasswordForm';
import UserProfileForm from '../profile/UserProfileForm';
import UserSubscriptionsForm from '../profile/UserSubscriptionsForm';
import { AH, AHLevelProvider } from '../../consumer/shared/AccessibleHeading';

const ProfileForm = ({
  afterSignOut = null,
  classes,
  currentUser = null,
  isAdmin = false,
}) => {
  if (!currentUser) {
    return null;
  }
  return (
    <React.Fragment>
      <AH typography variant="h3" align="center" gutterBottom><FormattedMessage defaultMessage="Profile" /></AH>
      <AHLevelProvider>
        <UserAvatarForm />

        <UserProfileForm />
        <Divider className={classes.profileDivider} />

        <UserPasswordForm />
        <Divider className={classes.profileDivider} />

        {isAdmin && currentUser.authyStatus !== 'authy_enabled' && (
          <React.Fragment>
            <AuthySummary />
            <Divider className={classes.profileDivider} />
          </React.Fragment>
        )}

        <UserSubscriptionsForm />
        <Divider className={classes.profileDivider} />

        <Typography align="center">
          <SignOutButton
            isAdmin={isAdmin}
            onCompleted={afterSignOut}
          />
        </Typography>
      </AHLevelProvider>
    </React.Fragment>
  );
};

ProfileForm.propTypes = {
  afterSignOut: PropTypes.func,
  classes: PropTypes.object.isRequired,
  currentUser: currentUserShape,
  isAdmin: PropTypes.bool,
};

export default withCurrentUser(withStyles(profileStyles)(ProfileForm));
